export const signalType = (strength) => {
  switch (strength) {
    case "5":
      return "Excellent";
    case "4":
      return "Very Good";
    case "3":
      return "Good";
    case "2":
      return "Fair";
    case "1":
      return "Weak";
    default:
      return "No Signal";
  }
};

export const signalTypeByRssi = (rssi) => {
  switch (true) {
    case rssi === -85:
    case rssi < 51 || rssi > 113:
      return "No Signal";
    case rssi < 65:
      return "Excellent";
    case rssi < 75:
      return "Very Good";
    case rssi < 85:
      return "Good";
    case rssi < 95:
      return "Fair";
    case rssi < 111:
      return "Weak";
    default:
      return rssi;
  }
};

export const signalTextToRssi = (text) => {
  switch (true) {
    case text === "No Signal":
      return [51, 113];
    case text === "Excellent":
      return [65, 51];
    case text === "Very Good":
      return [75, 65];
    case text === "Good":
      return [85, 75];
    case text === "Fair":
      return [95, 85];
    case text === "Weak":
      return [115, 95];
    default:
      return text;
  }
};

export const strengthAndQualityType = (value) => {
  switch (value) {
    case "1":
      return "Weak";
    case "2":
      return "Fair";
    case "3":
      return "Good";
    case "4":
      return "Excellent";
    default:
      return "No Signal";
  }
};
